/**
 * @deprecated Use Angle.js
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AngleDownIcon = ({
  color = '#B5BCBD',
  className,
  width = '24',
  height = '14',
  ...props
}) => (
  <svg
    viewBox="0 0 24 14"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    {...props}
  >
    <path
      fill={color}
      d="M.107 2.113l2.1-2.1 8.3 8.3 1.5 1.5 1.5-1.5 8.3-8.3 2.1 2.1-11.9 11.9z"
    />
  </svg>
);

AngleDownIcon.propTypes = propTypes;

export default AngleDownIcon;
